import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

  const StyledTextField = styled((props) => (
    <TextField {...props} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
      ))(({ theme }) => ({

      }));

  export default function AxionTextBox(props) {
    const { name, sx, label, value, defaultValue, error=null, size, onChange, disabled, ...other } = props;
    return (

          <StyledTextField
            label={label}
            value={value}
            defaultValue={defaultValue}
            id={name}
            sx={sx}
            size="small"
            variant="standard"
            onChange={onChange}
            disabled={disabled} 
          />

    );
  };

